import { useAtom } from 'jotai';
import { RESET } from 'jotai/utils';
import { useCallback, useLayoutEffect, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Background } from 'reactflow';

import { atomInfoModalPreviewRulePage, atomRuleData } from '@/src/modules/RulesModule/atoms/rules';
import { useInitialFlow } from '@/src/modules/RulesModule/hooks/useInitialFlow';

import Edges from './Components/Edges/Edges';

import 'reactflow/dist/style.css';
import './RulesDetail.css';

import { useHiddenV1Container } from '@/modules/AutomationModuleNew/hooks/useHiddenV1Container';
import ModalPreviewRulePage from '@/modules/RulesModule/components/FormRule/components/ModalPreviewRulePage';
import { useRedirectExternalCall } from '@/modules/RulesModule/components/FormRule/components/RedirectExternalUrl/useRedirectExternalCall';

const RulesDetail = () => {
  const { actionId } = useParams();
  const [infoModalPreview, setInfoModalPreview] = useAtom(atomInfoModalPreviewRulePage);
  const [rulesData, setRulesData] = useAtom(atomRuleData);
  const { contentHtmlPreviewRule, loading } = useRedirectExternalCall();
  const { generateInitialNodes, generateInitialEdges } = useInitialFlow();
  const initialNodes = useMemo(
    () => (rulesData.trigger ? generateInitialNodes({ trigger: rulesData.trigger }) : []),
    [generateInitialNodes, rulesData]
  );
  const initialEdges = useMemo(
    () => (rulesData.trigger ? generateInitialEdges() : []),
    [generateInitialEdges, rulesData]
  );

  const handleCloseModalPreview = useCallback(() => {
    setInfoModalPreview((prev) => ({ ...prev, isOpen: false }));
  }, [setInfoModalPreview]);

  useLayoutEffect(() => {
    if (rulesData.actionId !== Number(actionId)) {
      setRulesData(RESET);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useHiddenV1Container();

  return (
    <>
      <div className="wrapper-rules-detail h-[calc(100vh-112px)] w-full cursor-default overflow-hidden">
        <Background color="#F4F5FA" gap={16} size={4} />
        {/* <RulesProductTour /> */}
        {(initialEdges.length > 0 || initialNodes.length > 0) && (
          <Edges initialEdges={initialEdges} initialNodes={initialNodes} />
        )}
      </div>
      <ModalPreviewRulePage
        content={contentHtmlPreviewRule}
        loading={loading}
        open={infoModalPreview.isOpen}
        onClose={handleCloseModalPreview}
      />
    </>
  );
};

export default RulesDetail;
